export default __webpack_public_path__ + "static/media/Our-Services3.b4a2db6b.png";